export enum BydHttpStatusCodeEnum {
  UNAUTHORIZED = 401,
  INVALID_TOKEN = 498,
}
